export default __webpack_public_path__ + "static/media/august2024-4.b963db45.jpg";